import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Form } from 'react-bootstrap';
import { isJsonValueEmpty, isInt, isValueEmpty } from '@awp/helpers/utilsReact';
import Select from 'react-select';
import { SENSOR_PLACEMENT_CONFIG } from '@awp/constants';

import {
  isEditing,
  setEditing,
  //setPlacement,
  // setOrignPlacement,
  // savePlacement,
  //getSelectedPlacement,
  getSelectedSegment,
  getOrignSegment,
  setSegment,
  setOrignSegment,
  saveSegment,
  getObservationTypes,
  getNewSotId,
  setSotId,
  getSaveSegmentStatus,
  getSaveSegmentError,
  setSaveSegmentStatus,
} from '@stores/sensorEquipmentPacketSlice';

const sotitalicColStyle = {
  fontSize: '85%',
  fontStyle: 'italic',
  color: '#6c757d',
  borderTop: '0.063rem solid #bdc5cc',
  borderLeft: '0.063rem solid #bdc5cc',
  paddingTop: '0.2rem',
  paddingBottom: '0.2rem',
};
const sotColStyle = {
  borderTop: '0.063rem solid #bdc5cc',
  borderLeft: '0.063rem solid #bdc5cc',
  paddingTop: '0.2rem',
  paddingBottom: '0.2rem',
  fontSize: '85%',
};
const sotInput = {
  fontSize: '85%',
};
const sotInputItalic = {
  fontSize: '85%',
  fontStyle: 'italic',
  color: '#6c757d',
};

const pstyle = {
  cursor: 'pointer',
  paddingLeft: '0.375rem',
};

const stretchColStyle = {
  borderTop: '0.063rem solid #bdc5cc',
  borderLeft: '0.063rem solid #bdc5cc',
  paddingTop: '0.2rem',
  paddingBottom: '0.2rem',
  paddingRight: '0rem',
  fontSize: '80%',
  display: 'flex',
  alignItems: 'stretch',
  width: '20rem',
};

const SegmentObservationTypeEdit = ({ sot }) => {
  const dispatch = useDispatch();
  const selectedSegment = useSelector(getSelectedSegment);
  const observationTypeList = useSelector(getObservationTypes);
  const newSotId = useSelector(getNewSotId);
  const isSavedSegment = useSelector(getSaveSegmentStatus);
  const saveSegmentError = useSelector(getSaveSegmentError);

  const updateObservationType = (e) => {
    const id = e.value + '';
    let _ssot = getSelectedSot();
    let _selectedSot = { ...sot };
    if (_ssot) _selectedSot = _ssot;
    const ot = observationTypeList.find((opt) => opt.value == id);
    _selectedSot.ObservationTypeId = ot.value;
    _selectedSot.ObservationTypeDisplayName = ot.observationTypeDisplayName;
    _selectedSot.ObservationTypeName = ot.label;
    updateSegment(_selectedSot);
  };

  const updateDisplayName = (e) => {
    e.preventDefault();
    let _ssot = getSelectedSot();
    let _selectedSot = { ...sot };
    if (_ssot) _selectedSot = _ssot;
    _selectedSot.DisplayName = e.target.value + '';
    updateSegment(_selectedSot);
  };
  const toggleIsValid = () => {
    let _ssot = getSelectedSot();
    let _selectedSot = { ...sot };
    if (_ssot) _selectedSot = _ssot;
    _selectedSot.IsValid = _selectedSot.IsValid === 'N' ? 'Y' : 'N';
    updateSegment(_selectedSot);
  };
  const getSelectedSot = () => {
    let _selectedSegment = { ...selectedSegment };
    if (_selectedSegment && _selectedSegment.SegmentObservationTypes.length > 0) {
      _selectedSegment.SegmentObservationTypes.map((s) => {
        if (s.Id === sot.Id) {
          return s;
        }
      });
    }
    return null;
  };
  const updateSegment = (updatedSot) => {
    let _selectedSegment = { ...selectedSegment };
    let newSots = [];
    if (_selectedSegment && _selectedSegment.SegmentObservationTypes.length > 0) {
      _selectedSegment.SegmentObservationTypes.map((s) => {
        if (s.Id === updatedSot.Id) {
          newSots.push(updatedSot);
        } else {
          newSots.push(s);
        }
      });
    } else {
      newSots = _selectedSegment.SegmentObservationTypes;
    }
    _selectedSegment.SegmentObservationTypes = newSots;
    dispatch(setSegment(_selectedSegment));
  };

  const addNewSot = () => {
    let _selectedSegment = { ...selectedSegment };
    let newSots = [..._selectedSegment.SegmentObservationTypes];
    if (
      !_selectedSegment ||
      !_selectedSegment.SegmentObservationTypes ||
      _selectedSegment.SegmentObservationTypes.length === 0
    ) {
      newSots = [];
    }
    let _sot = { ...SENSOR_PLACEMENT_CONFIG.NEW_SEGMENT_OBSERVATION_TYPE };
    _sot.Id = newSotId;
    _sot.PlacementSegmentId = sot.PlacementSegmentId;
    newSots.push(_sot);
    _selectedSegment.SegmentObservationTypes = newSots;
    dispatch(setSegment(_selectedSegment));
    dispatch(setSotId(newSotId + 1));
  };

  const getError = (field) => {
    if (isJsonValueEmpty(saveSegmentError)) return '';
    let err = { ...saveSegmentError };
    //check property of dict obj
    field = (field + '').toLocaleLowerCase();
    for (let key in err) {
      let k = key.toLocaleLowerCase();
      if (!isValueEmpty(key) && k.startsWith(field)) {
        let id = k.replace(field + '.', '');
        if (isInt(id)) {
          if (sot.Id + '' === id + '') {
            return err[key];
          }
        }
      }
    }
    return '';
  };
  const deleteSot = (e) => {
    let _selectedSegment = { ...selectedSegment };
    let newSots = [];
    if (_selectedSegment && _selectedSegment.SegmentObservationTypes.length > 0) {
      _selectedSegment.SegmentObservationTypes.map((s) => {
        if (s.Id !== sot.Id) {
          newSots.push({ ...s });
        }
      });
    } else {
      return;
    }
    _selectedSegment.SegmentObservationTypes = newSots;
    dispatch(setSegment(_selectedSegment));
  };
  const isOnlySot = () => {
    return (
      !selectedSegment ||
      !selectedSegment.SegmentObservationTypes ||
      !isValueEmpty(sot.LastObservation) ||
      selectedSegment.SegmentObservationTypes.length < 2
    );
  };
  return (
    sot && (
      <Row className="bg-white">
        <Col style={sotColStyle} md={3}>
          <Select
            id={'observationTypePrefix_' + sot.ObservationTypeId + ''}
            options={observationTypeList}
            value={{
              value: sot.ObservationTypeId,
              label: sot.ObservationTypeName,
            }}
            placeholder={'Select ...'}
            onChange={updateObservationType}
          />
          {!isValueEmpty(getError('SegmentObservationType.ObservationTypeId')) && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {getError('SegmentObservationType.ObservationTypeId')}
            </Form.Control.Feedback>
          )}
        </Col>
        <Col style={sotColStyle} md={3}>
          <Form.Control
            id={'overrideDnPrefix-' + sot.Id + ''}
            onChange={updateDisplayName}
            style={isValueEmpty(sot.DisplayName) ? sotInputItalic : sotInput}
            type="text"
            maxLength="30"
            value={isValueEmpty(sot.DisplayName) ? '' : sot.DisplayName}
            placeholder={sot.ObservationTypeDisplayName}
          />
          {!isValueEmpty(getError('SegmentObservationType.DisplayName')) && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {getError('SegmentObservationType.DisplayName')}
            </Form.Control.Feedback>
          )}
        </Col>
        <Col style={sotColStyle} md={2}>
          {sot.IsValid === 'N' ? (
            <i onClick={toggleIsValid} className="bi bi-check-square text-danger" />
          ) : (
            <i onClick={toggleIsValid} className="bi bi-square" />
          )}
        </Col>
        <Col style={stretchColStyle} md={4}>
          {sot.LastObservation}
          <i onClick={() => addNewSot()} style={pstyle} className="bi bi-plus-circle-fill text-primary"></i>
          <i
            onClick={() => deleteSot()}
            style={isOnlySot() ? { pointerEvents: 'none', ...pstyle } : pstyle}
            disabled={isOnlySot()}
            className={isOnlySot() ? 'bi bi-dash-circle-fill text-secondary' : 'bi bi-dash-circle-fill text-primary'}
          ></i>
        </Col>
      </Row>
    )
  );
};

SegmentObservationTypeEdit.propTypes = {
  sot: PropTypes.any.isRequired,
};

export default SegmentObservationTypeEdit;
